import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";

import storage from "../../../Storage";
import { ChevronLeft, ChevronRight, InfoIcon, X } from "lucide-react";
import EngineCarousel from "./VipModalCraousel";
import socket from "../../../Socket";
import { API, decode, encode, getUID } from "../../../Helper";
import C from "../../../../src/Constant";
import "./VipClub.css";
import { getVipLevelDetails } from "./calculateLevel";
import VipClubFaq from "./VipClubFaq";
import VipPopUp from "./VipPopUp";
import VipPopUp1 from "./VipPopUp1";
import { fontSize } from "@mui/system";
import Cookies from "js-cookie";




const Container = styled.div`
  color: white;
  padding: 20px;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 20px;
`;

const CarouselContainer = styled.div`
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const CarouselTrack = styled.div`
  display: flex;
  gap: 20px;
  padding-bottom: 20px;
`;

const Card = styled.div`
  flex: 0 0 100%;
  scroll-snap-align: start;
  background-color: rgb(32, 34, 37);
  border-radius: 8px;
  padding: 20px;

  text-align: center;
  position: relative;

  @media (min-width: 600px) and (max-width: 767px) {
    flex: 0 0 calc(33.333% - 13.333px);
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    flex: 0 0 calc(33.333% - 13.333px);
  }

  @media (min-width: 1024px) {
    flex: 0 0 calc(20% - 16px);
  }
`;

const CardTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 10px;
  text-wrap: nowrap;
`;

const CardDescription = styled.p`
  font-size: 14px;
  color: #aaa;
`;

const Badge = styled.span`
  background-color: #4a4a4a;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  position: absolute;
  top: 10px;
  right: 10px;
`;

const CardContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 8rem;
  border-radius: 8px;
`;

const BackgroundImage = styled.img`
  width: 100%;
  height: 60%;
  object-fit: contain;
  border-radius: 8px;
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const BenefitCard = styled.div`
  background-color: #2a2a2a;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
`;

const BenefitImage = styled.img`
  width: 100%;
  object-fit: cover;
  margin-bottom: 15px;
`;

const NavigationButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`;

const BenefitTitle = styled.h2`
  color: white;
  margin-bottom: 10px;
  font-size: 16px;
`;

const BenefitDescription = styled.p`
  color: #bbb;
  font-size: 12px;
`;

const CarouselContainerVip = styled.div`
  margin-right: 170px;
  @media (max-width: 454px) {
    margin-right: 90px !important;
  }
  @media (max-width: 284px) {
    margin-right: 50px !important;
  }
`;

const CardVip = styled.div`
  color: white;
  border-radius: 10px;
  padding: 20px;
  width: 100%;
  position: relative;
  cursor: pointer;
`;

const LeftButton = styled(NavigationButton)`
  left: 10px;
`;

const RightButton = styled(NavigationButton)`
  right: 9px;
`;

const ProgressBarContainer = styled.div`
  width: 100%;

  height: 150px;
  padding: 10px;

  @media (max-width: 854px) {
    display: flex;
    justify-content: space-around;
  }
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: #2f3136;
  border-radius: 4px;
  overflow: hidden;
`;

const Progress = styled.div`
  width: ${(props) => props.progress}%;
  height: 100%;
  background-color: #5865f2;
  border-radius: 4px;
`;

const LevelIndicator = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  margin-bottom: 8px;
`;

const LevelCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  fontSize: "clamp(5px,2vw,16px)",
  margin-right: 8px;
  text-transform: no-wrap;
`;

const LevelText = styled.span`
  color: #72767d;
  font-size: 14px;
`;

const StatsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  color: #72767d;
  font-size: 12px;
`;

const MainWrapper = styled.div`
  display: flex;
  height: 180px;
  gap: 10px;
  align-items: center;
  margin-top: 20px;
  position: relative;
`;

const InfoContainer = styled.div`
  flex: 1;
`;

const InfoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;

const FlexContainerStar = styled.div`
  gap: 5px;
`;

const CustomModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: #17181b;
  color: white;
  width: 900px;
  border-radius: 8px;
  padding: 20px;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ModalTitle = styled.div`
  margin: 0;
  font-size: 18px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
`;

const ModalBody = styled.div`
  max-height: 80vh;
  overflow-y: auto;
`;

const cardData = [
  {
    title: "Bronze Card",
    description: "Smart Player",
    subtitle: "You deserve the best",
    imageSrc: "/assets/images/vip-new/vip-1.webp",
  },
  {
    title: "Silver Card",
    description: "VIP Player",
    subtitle: "Enjoy exclusive benefits",
    imageSrc: "/assets/images/vip-new/vip-3.webp",
  },
  {
    title: "Gold Card",
    description: "Elite Player",
    subtitle: "Experience luxury gaming",
    imageSrc: "/assets/images/vip-new/vip-4.png",
  },
  {
    title: "Platinum Card",
    description: "Elite Player",
    subtitle: "Experience luxury gaming",
    imageSrc: "/assets/images/vip-new/vip-5.webp",
  },
  {
    title: "Diamond Card",
    description: "Elite Player",
    subtitle: "Experience luxury gaming",
    imageSrc: "/assets/images/vip-new/vip-2.webp",
  },
];

const cards = [
  {
    title: "Roll Competition",
    description:
      "Try your luck once a day for a spot on our daily top 10 and win some free Doge!",
    badge: "V03",
    img: "https://static.nanogames.io/assets/dice.cb7509e5.png",
  },
  {
    title: "Tip",
    description:
      "Send a little (or a lot of) luck to your friends, you've earned the ability to tip others.",
    badge: "V04",
    img: "https://static.nanogames.io/assets/money.9316ba83.png",
  },
  {
    title: "Secret Treasure",
    description: "The higher rank you are, the more surprising it will be",
    badge: "V04",
    img: "https://static.nanogames.io/assets/secret.5ee36c98.png",
  },
  {
    title: "Private chat",
    description:
      "Send messages and chat with your closest friends in private on-site",
    badge: "V04",
    img: "https://static.nanogames.io/assets/dice.cb7509e5.png",
  },
  {
    title: "Raining",
    description: "Randomly reward players in chat room every 6 hours.",
    badge: "V04",
    img: "https://static.nanogames.io/assets/rain.81aa4c59.png",
  },
  {
    title: "Coindrop",
    description:
      "You can now get coin drops from the chatroom for a little extra luck!",
    badge: "V07",
    img: "https://static.nanogames.io/assets/coindrop.2d362bea.png",
  },
  {
    title: "VIP Lounge",
    description:
      "Access exclusive VIP areas with special promotions and bonuses.",
    badge: "V08",
    img: "https://static.nanogames.io/assets/rain.81aa4c59.png",
  },
  {
    title: "Priority Support",
    description: "Get faster responses from our dedicated VIP support team.",
    badge: "V09",
    img: "https://static.nanogames.io/assets/dice.cb7509e5.png",
  },
];

const benefits = [
  {
    title: "Unique VIP Transfer Program",
    description:
      "Hellogames.IO respects and welcomes every distinguished VIP and will give you an exclusive VIP status that you can continue your honor here. Contact us for details.",
    imagePlaceholder: "https://static.nanogames.io/assets/emoji_m.ae3b136b.png",
  },
  {
    title: "Exclusive VIP Host",
    description:
      "There will be exclusive host for every VIP. Feel free to contact them any time.",
    imagePlaceholder:
      "https://static.nanogames.io/assets/wallet_m.747f1dcc.png",
  },
  {
    title: "The SVIP Code",
    description:
      "Only SVIP can get code from exclusive host. Become an SVIP, rock like a superstar and have the spotlight shining on you!",
    imagePlaceholder: "https://static.nanogames.io/assets/start_m.7bbee082.png",
  },
];

const VipClub = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showVipLevelModal, setShowVipLevelModal] = useState(false);
  const [vipDetails, setVipDetails] = useState(null);
  const [progress, setProgress] = useState(0);
  const carouselRef = useRef(null);
  const progressAnimationRef = useRef(null);

  const [wageredAmount, setWagredAmount] = useState(null);
  const [userInfo, setUserInfo] = useState({})
  const [levelList, setLeverList] = useState([])

  const animateProgress = (targetProgress) => {
    let currentProgress = 0;
    const duration = 1000; // 1 second animation
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      currentProgress = progress * targetProgress;
      setProgress(currentProgress);

      if (progress < 1) {
        progressAnimationRef.current = requestAnimationFrame(animate);
      }
    };

    progressAnimationRef.current = requestAnimationFrame(animate);
  };
  function parseWageredAmount(amountString) {
    if (!amountString) return 0; // Handle null or undefined data
    let cleanedAmount = amountString.replace(/,/g, ""); // Remove any commas
    let parsedAmount = parseFloat(cleanedAmount); // Convert to float
    return isNaN(parsedAmount) ? 0 : parsedAmount; // Return 0 if parsing fails
  }

  const getUserInfo = (data) => {
    if (data.status) {
      // console.log("data comes", data);

      let waggerAmount = parseWageredAmount(data?.profit).toFixed(4);
      // console.log("wagamnounbt", wageredAmount);
      if (waggerAmount) {
        setWagredAmount(waggerAmount);
        const vipDetails = getVipLevelDetails(waggerAmount);
        // console.log("vippp", vipDetails);
        setVipDetails(vipDetails);
        // Animate progress based on completion percentage
        // animateProgress(parseFloat(vipDetails.completionPercentage));
      }
    } else {
      // console.log("called");
    }
  };

  useEffect(() => {
    socket.on(C.USER_INFO, (data) => getUserInfo(decode(data)));
    socket.emit(
      C.USER_INFO,
      encode({
        id: getUID,
        coin: storage.getKey("coin") ? storage.getKey("coin") : "",
        rate: null,
        game: "all",
        first: true,
      })
    );

    // Cleanup animation on unmount
    return () => {
      if (progressAnimationRef.current) {
        cancelAnimationFrame(progressAnimationRef.current);
      }
    };
  }, []);

  useEffect(() => {
    socket.on(C.USER_INFO, (data) => getUserInfo(decode(data)));
    socket.emit(
      C.USER_INFO,
      encode({
        id: getUID,
        coin: storage.getKey("coin") ? storage.getKey("coin") : "",
        rate: null,
        game: "all",
        first: true,
      })
    );
  }, []);

  useEffect(() => {
    const username =
      storage.getKey("name") !== undefined ? storage.getKey("name") : "Guest";
    // console.log(username, "useee");
  }, []);

  const handlePrev = (e) => {
    e.stopPropagation();
    setActiveIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : cardData.length - 1
    );
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setActiveIndex((prevIndex) =>
      prevIndex < cardData.length - 1 ? prevIndex + 1 : 0
    );
  };

  const handleCardClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleVipLevelClick = () => {
    setShowVipLevelModal(true);
  };

  const handleCloseVipLevelModal = () => {
    setShowVipLevelModal(false);
  };

  const activeCard = cardData[activeIndex];
  const [uid] = useState(getUID); // Get UID immediately from cookie

  useEffect(async () => {
          
          // Fetch all data immediately
         await getMyProfile();
         await getLevel();
      }, []);

      const getMyProfile = () => {
        fetch(`${API}/api/myproifle/${uid}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then(response => response.json())
        .then(data => {
            if (data?.data) {
                setUserInfo(data?.data[0]);
                // console.log(data)
            }
           
        })
        .catch(error => console.log("error", error));
      };
      const getLevel = () => {
        fetch(`${API}/admin/getLevel`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then(response => response.json())
        .then(data => {
            if (data?.data) {
                setLeverList(data?.data);
            }
        })
        .catch(error => console.log("error", error));
      };


      const [currentLevel, setCurrentLevel] = useState(0);  
const [nextLevelAmount, setNextLevelAmount] = useState(0);  
const [currentLevelAmount, setCurrentLevelAmount] = useState(0);  
const [progressPercentage, setProgressPercentage] = useState(0);  

function calculateLevelPercentage() {
    if (!userInfo || !levelList?.length) return; // ✅ Prevent errors if data is missing

    let myTotalBet = userInfo.total_bet_amount || 0;
    let currentLevel = 0;
    let currentLevelAmount = 0;
    let nextLevelAmount = 0;

    // ✅ Find the highest level user qualifies for
    for (let i = 0; i < levelList.length; i++) {
        if (myTotalBet >= levelList[i].total_bet_amt) {
            currentLevel = levelList[i].level;
            currentLevelAmount = levelList[i].total_bet_amt;
        } else {
            nextLevelAmount = levelList[i].total_bet_amt;
            break; // ✅ Stop at the first level user hasn't reached
        }
    }

    // ✅ Calculate progress percentage relative to the next level
    let progressPercentage = 0;
    if (nextLevelAmount > currentLevelAmount) {
        progressPercentage = ((myTotalBet - currentLevelAmount) / (nextLevelAmount - currentLevelAmount)) * 100;
    }

    // ✅ Update states
    setCurrentLevel(currentLevel);
    setCurrentLevelAmount(currentLevelAmount);
    setNextLevelAmount(nextLevelAmount);
    setProgressPercentage(progressPercentage);
    
    // ✅ Smoothly animate progress (if needed)
    animateProgress(parseFloat(progressPercentage));

    console.log(`Current Level: ${currentLevel}`);
    console.log(`Progress: ${progressPercentage.toFixed(2)}%`);
}

// ✅ Recalculate whenever userInfo or levelList changes
useEffect(() => {
    calculateLevelPercentage();
}, [userInfo, levelList]);

      
    


    

  return (
    <container>
      {/* <CardContainer>
        <div style={{ position: "relative", width: "100%" }}>
          <BackgroundImage src="/assets/images/bg_m.png" alt="VIP background" />
          <div style={{ position: "absolute", top: "114px", right: "0" }}>
            <div style={{ fontSize: "32px", fontWeight: "bold" }}>VIP-CLUB</div>
            <div style={{ fontSize: "32px", fontWeight: "bold" }}>
              Exclusive Player Benefits
            </div>
            <div style={{ width: "600px", fontSize: "16px" }}>
              As a way of showing our gratitude and appreciation to our VIP
              players, {process.env.REACT_APP_LINK} invites you to join our VIP Club where there
              is an abundance of gifts, giveaways, higher cash back and unique
              features. Don't miss out on all the exciting and amazing fun!
            </div>
          </div>
        </div>
      </CardContainer> */}
     
      {
        storage.getKey('logged') ? (<>
         <div
        style={{
          borderRadius: "10px",
          background:
            "linear-gradient(rgba(93, 129, 172, 0.4) 0%, rgba(50, 55, 56, 0) 77.42%)",
        }}
      >
        <div className="vipclub-main-page">
          <MainWrapper>
            <CarouselContainerVip>
              {/* <CardVip>
            <img
              onClick={handleCardClick}
              src={activeCard.imageSrc}
              style={{ height: "170px", width: "292px", objectFit: "contain" }}
              alt="VIP Card"
            />
            <LeftButton onClick={handlePrev}>
              <ChevronLeft size={20} />
            </LeftButton>
            <RightButton onClick={handleNext}>
              <ChevronRight size={20} />
            </RightButton>
          </CardVip> */}

              <div className="image-logo-main-in">
                <img
                  className="image-logo-main-inner"
                  src="/assets/bcimages/vipclub/badge-none.webp"
                />
              </div>
            </CarouselContainerVip>
            <InfoContainer>
              <ProgressBarContainer>
                <div className="image-main-banner-in">
                  <LevelIndicator>
                    <LevelCircle className="Vip-0-in">
                      {/* {vipDetails?.previousVipLevel
                        ?.replace("IP", "")
                        .replace(" ", "") || "VIP 0"} */}
                      {/* {'BET $'+ userInfo?.total_bet_amount} */}
                      {'VIP '+ currentLevel}
                    </LevelCircle>
                  </LevelIndicator>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "clamp(5px,2vw,16px)",
                    }}
                  >
                    <div>{"$ "}{currentLevelAmount || "Your VIP Progress"}</div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {/* <div>{progressPercentage.toFixed(2)}%</div> */}
                      {/* <InfoIcon className="info-icon-1" /> */}
                      <div>{"$ "}{nextLevelAmount}</div>
                      <InfoIcon className="info-icon-1" />
                    </div>
                  </div>
                  
                  <ProgressBar>
                    <Progress progress={progress} />
                  </ProgressBar>
                  <StatsContainer>
                    {/* <span>
                    Your current XP:{" "}
                    <span style={{ color: "white" }}>
                      {vipDetails?.currentWagger || "0"} XP
                    </span>{" "}
                    / Total wager:{" "}
                    <span style={{ color: "white" }}>
                      {vipDetails?.currentWagger || "0.00"} USD
                    </span>
                  </span>
                  <span>
                    Reach{" "}
                    <span style={{ color: "white" }}>
                      {vipDetails?.waggerNeededForNextLevel || "1"} XP
                    </span>{" "}
                    to <span>{vipDetails?.vipLevel || "VIP1"}</span>
                  </span> */}
                    <div className="about-vip-level"
                    // onClick={handleVipLevelClick}
                    >
                       {'BET $'+ userInfo?.total_bet_amount} 
                      {/* <VipPopUp /> */}
                    </div>
                  </StatsContainer>
                </div>
              </ProgressBarContainer>
            </InfoContainer>
          </MainWrapper>
          <VipPopUp1 />
        </div>
      </div>
      <div className="vip-svip-main">
        <div className="vip-svip-heading">Exclusive VIP Bonus</div>
        <div className="vip-svip-text-in">
          Discover the ultimate gaming experience
        </div>
      </div>
      <div style={{ display: "flex", width: "100%" }}>
        <div className="table-main-1">
          <div
            style={{ backgroundColor: "#292D2E" }}
            className="table-item-flex"
          >
            <div style={{ color: "#849194", fontWeight: "bold" }}>
              Bonus Type
            </div>
          </div>
          <div className="table-item-flex">
            <img src="/assets/bcimages/vipclub/icon-raining.webp" />
            <div>Raining </div>
          </div>
          <div className="table-item-flex">
            <img src="/assets/bcimages/vipclub/icon-coin-drop.webp" />
            <div>Coin Drops</div>
          </div>
          <div className="table-item-flex">
            <img src="/assets/bcimages/vipclub/icon-host.webp" />
            <div>Private Chat</div>
          </div>{" "}
          <div className="table-item-flex">
            <img src="/assets/bcimages/vipclub/icon-tips.webp" />
            <div>Tips</div>
          </div>{" "}
          <div className="table-item-flex">
            <img src="/assets/bcimages/vipclub/icon-spin.webp" />
            <div>VIP Spin</div>
          </div>{" "}
          <div className="table-item-flex">
            <img src="/assets/bcimages/vipclub/card-img-bonus.webp" />
            <div>Level-up Bonus</div>
          </div>{" "}
          <div className="table-item-flex">
            <img src="/assets/bcimages/vipclub/icon-recharge.webp" />
            <div>Recharge</div>
          </div>{" "}
          <div className="table-item-flex">
            <img src="/assets/bcimages/vipclub/icon-cashback-weekly.webp" />
            <div>Weekly Cashback</div>
          </div>{" "}
          <div className="table-item-flex">
            <img src="/assets/bcimages/vipclub/icon-cashback-monthly.webp" />
            <div>Monthly Cashback</div>
          </div>{" "}
          <div className="table-item-flex">
            <img src="/assets/bcimages/vipclub/icon-sport.webp" />
            <div>Sports Cashback</div>
          </div>{" "}
          <div className="table-item-flex">
            <img src="/assets/bcimages/vipclub/icon-withdraw.webp" />
            <div>No-fee Withdrawal</div>
          </div>{" "}
        </div>
        <div className="table-main-2">
          <div className="heading-item-flex-1">
            <div
              style={{ fontSize: "clamp(8px,3vw,0.7rem)", fontWeight: "bold" }}
            >
              <img src="/assets/bcimages/vipclub/badge-bronze.webp" />
              <br />
              Bronze
            </div>
          </div>
          <div className="table-item-flex-1">
            <div className="star-icon-size">★ </div>
          </div>
          <div className="table-item-flex-1">
            <div className="star-icon-size">★</div>
          </div>
          <div className="table-item-flex-1">
            <div className="dot-icon-size">--</div>
          </div>{" "}
          <div className="table-item-flex-1">
            <div className="dot-icon-size">--</div>
          </div>{" "}
          <div className="table-item-flex-1">
            <div className="dot-icon-size">--</div>
          </div>{" "}
          <div className="table-item-flex-1">
            <div className="dot-icon-size">--</div>
          </div>{" "}
          <div className="table-item-flex-1">
            <div className="dot-icon-size">--</div>
          </div>{" "}
          <div className="table-item-flex-1">
            <div className="dot-icon-size">--</div>
          </div>{" "}
          <div className="table-item-flex-1">
            <div className="dot-icon-size">--</div>
          </div>{" "}
          <div className="table-item-flex-1">
            <div className="dot-icon-size">--</div>
          </div>{" "}
          <div className="table-item-flex-1">
            <div className="dot-icon-size">--</div>
          </div>{" "}
        </div>
        <Swiper
          modules={[Navigation]}
          spaceBetween={0}
          slidesPerView={1}
          navigation={{
            nextEl: ".custom-next-arrow",
            prevEl: ".custom-prev-arrow",
          }}
          breakpoints={{
            650: {
              slidesPerView: 2,
            },
            1021: {
              slidesPerView: 4,
            },
          }}
        >
          {/* Custom Left Navigation Arrow */}

          {/* Left Navigation Arrow */}

          <BiChevronLeft className="arrow-icon" />

          <SwiperSlide>
            <div className="table-main-3">
              <div
                className="heading-item-flex-1"
                style={{ backgroundColor: "#292D2E" }}
              >
                <div
                  style={{
                    fontSize: "clamp(8px,3vw,0.7rem)",
                    fontWeight: "bold",
                  }}
                >
                  <img src="/assets/bcimages/vipclub/badge-silver.webp" />
                  {/* <br /> */}
                  Silver
                </div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-silver">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-silver">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-silver">★</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-silver">★</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-silver">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="dot-icon-size">--</div>
              </div>
              <div className="table-item-flex-1">
                <div className="dot-icon-size">--</div>
              </div>
              <div className="table-item-flex-1">
                <div className="dot-icon-size">--</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="dot-icon-size">--</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="dot-icon-size">--</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="dot-icon-size">--</div>
              </div>{" "}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="table-main-3">
              <div
                style={{ backgroundColor: "#292D2E" }}
                className="heading-item-flex-1"
              >
                <div
                  style={{
                    fontSize: "clamp(8px,3vw,0.7rem)",
                    fontWeight: "bold",
                  }}
                >
                  <img src="/assets/bcimages/vipclub/badge-#9fe871.webp" />
                  {/* <br /> */}
                  Gold
                </div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-#9fe871">★ </div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-#9fe871">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-#9fe871">★</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-#9fe871">★</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-#9fe871">★</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-#9fe871">★</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-#9fe871">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="dot-icon-size">--</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="dot-icon-size">--</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="dot-icon-size">--</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="dot-icon-size">--</div>
              </div>{" "}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="table-main-3">
              <div
                style={{ backgroundColor: "#292D2E" }}
                className="heading-item-flex-1"
              >
                <div
                  style={{
                    fontSize: "clamp(8px,3vw,0.7rem)",
                    fontWeight: "bold",
                  }}
                >
                  <img src="/assets/bcimages/vipclub/badge-platinum.webp" />
                  {/* <br /> */}
                  Platinum I-II
                </div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-Platinum">★ </div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-Platinum">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-Platinum">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-Platinum">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-Platinum">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-Platinum">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-Platinum">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-Platinum">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-Platinum">★</div>
              </div>
              <div className="table-item-flex-1">
                <div className="dot-icon-size">--</div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="dot-icon-size">--</div>
              </div>{" "}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="table-main-3">
              <div
                style={{ backgroundColor: "#292D2E" }}
                className="heading-item-flex-1"
              >
                <div
                  style={{
                    fontSize: "clamp(8px,3vw,0.7rem)",
                    fontWeight: "bold",
                  }}
                >
                  <img src="/assets/bcimages/vipclub/badge-diamond.webp" />
                  {/* <br /> */}
                  Diamond I-III
                </div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-Diamond">★ </div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-Diamond">★ </div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-Diamond">★ </div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-Diamond">★ </div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-Diamond">★ </div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-Diamond">★ </div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-Diamond">★ </div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-Diamond">★ </div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-Diamond">★ </div>
              </div>{" "}
              <div className="table-item-flex-1">
                <div className="star-icon-Diamond">★ </div>
              </div>
              <div className="table-item-flex-1">
                <div className="star-icon-Diamond">★ </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Custom Right Navigation Arrow */}
          <div className="custom-prev-arrow">
            <BiChevronLeft className="custom-arrow-icon" />
          </div>
          <div className="custom-next-arrow">
            <BiChevronRight className="custom-arrow-icon" />
          </div>
        </Swiper>
      </div>
        </>) : 
        (<>
          <div className="main-card-page-container">
          <div className="main-card-page-in">
            <div className="card-page-inner">
              <img src="/assets/bcimages/vipclub/card-img-withdraw.webp" />
              <div className="card-page-text">
                No-fee <br /> Withdrow
              </div>
              <div className="card-image-text" style={{ color: "#B3BEC1" }}>
                Reach VIP 38 for no-fee <br /> cryptocurrency withdrawals.
              </div>
            </div>
          </div>
  
          <div className="main-card-page-in">
            <div className="card-page-inner">
              <img src="/assets/bcimages/vipclub/card-img-spin.webp" />
              <div className="card-page-text">
                No-fee <br /> Withdrow
              </div>
              <div className="card-image-text" style={{ color: "#B3BEC1" }}>
                Reach VIP 38 for no-fee <br /> cryptocurrency withdrawals.
              </div>
            </div>
          </div>
  
          <div className="main-card-page-in">
            <div className="card-page-inner">
              <img src="/assets/bcimages/vipclub/card-img-host.webp" />
              <div className="card-page-text">
                No-fee <br /> Withdrow
              </div>
              <div className="card-image-text" style={{ color: "#B3BEC1" }}>
                Reach VIP 38 for no-fee <br /> cryptocurrency withdrawals.
              </div>
            </div>
          </div>
          <div className="main-card-page-in">
            <div className="card-page-inner">
              <img src="/assets/bcimages/vipclub/card-img-chat.webp" />
              <div className="card-page-text">
                No-fee <br /> Withdrow
              </div>
              <div className="card-image-text" style={{ color: "#B3BEC1" }}>
                Reach VIP 38 for no-fee <br /> cryptocurrency withdrawals.
              </div>
            </div>
          </div>
          <div className="main-card-page-in">
            <div className="card-page-inner">
              <img src="/assets/bcimages/vipclub/card-img-bonus.webp" />
              <div className="card-page-text">
                No-fee <br /> Withdrow
              </div>
              <div className="card-image-text" style={{ color: "#B3BEC1" }}>
                Reach VIP 38 for no-fee <br /> cryptocurrency withdrawals.
              </div>
            </div>
          </div>
          <div className="main-card-page-in">
            <div className="card-page-inner">
              <img src="/assets/bcimages/vipclub/card-img-cashback.webp" />
              <div className="card-page-text">
                No-fee <br /> Withdrow
              </div>
              <div className="card-image-text" style={{ color: "#B3BEC1" }}>
                Reach VIP 38 for no-fee <br /> cryptocurrency withdrawals.
              </div>
            </div>
          </div>
        </div>
  
        <VipClubFaq />
          </>)
      }
     

      {showModal && (
        <CustomModal>
          <ModalContent>
            <ModalHeader>
              <ModalTitle>About VIP Cards</ModalTitle>
              <CloseButton onClick={handleCloseModal}>
                <X size={20} />
              </CloseButton>
            </ModalHeader>
            <ModalBody>
              <img
                src={activeCard.imageSrc}
                style={{
                  height: "170px",
                  width: "292px",
                  objectFit: "contain",
                }}
                alt="VIP Card"
              />
              <h3>{activeCard.title}</h3>
              <p>{activeCard.description}</p>
              <p>{activeCard.subtitle}</p>
            </ModalBody>
          </ModalContent>
        </CustomModal>
      )}

    </container>
  );
};

export default VipClub;
